<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false"
           @on-ok="ok" :loading="loading" @on-cancel="cancel"
           @on-visible-change="changeVisible"
    >
      <h3 slot="header" class="modal-header">修改VR房源</h3>
      <Form :label-width="100" ref="formData" :rules="formRules" :model="formData" v-if="formData">
        <FormItem label="业务线" prop="serviceType">
          <Select class="width100" v-model="formData.serviceType" @on-change="changeServiceType">
            <Option value="">请选择</Option>
            <Option v-for="item in serviceTypeList" :value="item.value" :key="'ownertype'+item.value">{{item.text}}
            </Option>
          </Select>
        </FormItem>

        <FormItem label="项目" prop="projectFid">
          <Select class="width100" v-model="formData.projectFid" @on-change="changeProject">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </FormItem>

        <FormItem label="楼栋" prop="buildingFid">
          <Select class="width100" v-model="formData.buildingFid" @on-change="changeBuild">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in buildingList" :value="item.value" :key="'keyC'+index">{{item.text}}</Option>
          </Select>
        </FormItem>
        <FormItem label="类型" prop="areaType" >
          <Select class="width100" v-model="formData.areaType" @on-change="changeAreaType">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in typeList" :value="item.value" :key="'keyK'+index">{{item.text}}</Option>
          </Select>
        </FormItem>
        <div v-if="formData.areaType===1">
          <FormItem label="房型名称" prop="moduleFid1">
            <Select class="width100" v-model="formData.moduleFid1" @on-change="changeModule1">
              <Option value="">请选择</Option>
              <Option v-for="(item,index) in moduleFid1List" :value="item.value" :key="'keyG'+index">{{item.text}}
              </Option>
              <!--<Option v-for="item in ownerTypeList" :value="item.value" :key="'ownertype'+item.value">{{item.text}}</Option>-->
            </Select>
          </FormItem>
          <FormItem label="房源编号" prop="roomFid">
            <Select class="width100"
                    filterable
                    remote
                    :remote-method="forHouseType"
                    v-model="formData.roomFid"
                    placeholder="请填写房源Id"
                    :label="roomLabel"
                    :not-found-text="''"

            >
              <Option v-for="item in roomList" :value="item.value" :key="'keyHH'+item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </div>
        <FormItem label="公区名称" prop="moduleFid2" v-if="formData.areaType===2">
          <Select class="width100" v-model="formData.moduleFid2" :multiple="true">
            <Option v-for="(item,index) in moduleFid2List" :value="item.value" :key="'keyP'+index">{{item.text}}
            </Option>

          </Select>
        </FormItem>
        <FormItem label="贝壳houseID" prop="shellHouseId">
          <Input v-model="formData.shellHouseId" placeholder="请填写贝壳houseId"/>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
  import {
    projectAndBuild, forProjectAndBuild, forHouseType,
    housetypeforProject, vrupdate
  } from "../../../api/vrmanage";
  import {deepClone} from "../../../utils/format";

  export default {
    name: "",
    components: {},
    props: {
      n: {
        type: Number,
        default: 0
      },
      serviceTypeList: {
        type: Array,
        default: () => {
          return []
        }
      },
      formDataOri: {
        type: Object,
        default: null
      },
    },

    watch: {
      n() {
        // this.clearData()
        this.isShow = true
      },

      formDataOri(value) {
        console.log(2222)
        console.log(value)
        this.clearData()
        if (!value) {
          return
        }



        let p1, p2, p3, p4
        let value1 = deepClone(value)
        value1['moduleFid1'] = ''
        value1['moduleFid2'] = []
        if (value.serviceType) {
          p1 = projectAndBuild({
            serviceType: value.serviceType
          }).then(res => {
            this.projectList = res.data
            value.projectFid && (this.buildingList = this.projectListMap['' + value.projectFid].children)

          }).catch(error => {
          })
        }

        if (value.projectFid && value.serviceType) {
          let params2 = {
            projectFid: value.projectFid,
            serviceType: value.serviceType,
          }
          p3 = housetypeforProject(params2).then(res => {
            this.moduleFid1List = res.data
          }).catch(error => {
          })
        }
        if (value.projectFid && value.buildingFid && value.serviceType) {
          let params1 = {
            projectFid: value.projectFid,
            buildingFid: value.buildingFid,
            serviceType: value.serviceType,
          }
          p2 = forProjectAndBuild(params1).then(res => {
            this.moduleFid2List = res.data
          }).catch(error => {
          })
        }

        if (value.moduleFid) {
          if (value.areaType === 1) {
            value1.moduleFid1 = value.moduleFid
          }
          else {
            value1.moduleFid2 = value.moduleFid.split(',')
          }

        }
        if(value.roomName){
          this.roomLabel=value.roomName

        }

        // if (value.roomFid) {
        //   let params3 = {
        //     projectFid: value.projectFid,
        //     buildingFid: value.buildingFid,
        //     houseTypeFid: value.moduleFid,
        //     roomnumber: value.roomName,
        //     serviceType: value.serviceType,
        //   }
        //
        //   p4 = forHouseType(params3).then(res => {
        //     this.roomList = res.data
        //   }).catch(error => {
        //   })
        // }
        Promise.all([p1, p2, p3,]).then(res => {
          this.formData = value1
          this.$refs['formData'] && this.$refs['formData'].resetFields()
        })
      }


    },
    computed: {
      projectListMap() {
        let ret = {}
        this.projectList.forEach(ele => {
          ret[ele.value + ''] = ele
        })
        return ret
      },

    },
    data() {
      return {
        roomLabel:'',
        buildingListMap: null,
        moduleFid1ListMap: null,
        moduleFid2ListMap: null,
        roomListMap: null,
        formData: null,
        roomList: [],
        moduleFid1List: [],
        moduleFid2List: [],
        buildingList: [],
        typeList: [{text: '房源', value: 1}, {text: '公区', value: 2}],
        houseTypeAndAreaList: [],
        projectList: [],
        loading: true,
        isShow: false,
        // formData: {
        //   moduleFid2: [],
        //   moduleFid1: '',
        //   "areaType": '',
        //   "buildingFid": "",
        //   "moduleFid": "",
        //   "projectFid": "",
        //   "roomFid": "",
        //   "serviceType": '',
        //   "shellHouseId": "",
        // },
        formRules: {
          moduleFid2: [
            {required: true, message: ' ', trigger: 'change', type: 'array'}
          ],
          moduleFid1: [{required: true, message: ' ', trigger: 'change', type: 'string'}],
          "areaType": [{required: true, message: ' ', trigger: 'change', validator: this.validateNumber}],
          "buildingFid": [{required: true, message: ' ', trigger: 'change', type: 'string'}],
          // "moduleFid": "string",
          "projectFid": [{required: true, message: ' ', trigger: 'change', type: 'string'}],
          "roomFid": [{required: true, message: ' ', trigger: 'change', type: 'string'}],
          "serviceType": [{required: true, message: ' ', trigger: 'change', validator: this.validateNumber}],
          "shellHouseId": [{required: true, message: ' ', trigger: 'blur', type: 'string'}],

        },
      }
    },
    methods: {
      setbuildingListMap() {
        let ret = {}
        this.buildingList.forEach(ele => {
          ret[ele.value + ''] = ele.text
        })
        this.buildingListMap = ret
      },
      setmoduleFid1ListMap() {
        let ret = {}
        this.moduleFid1List.forEach(ele => {
          ret[ele.value + ''] = ele.text
        })
        this.moduleFid1ListMap = ret
      },
      setmoduleFid2ListMap() {
        let ret = {}
        this.moduleFid2List.forEach(ele => {
          ret[ele.value + ''] = ele.text
        })
        this.moduleFid2ListMap = ret

      },
      setroomListMap() {
        let ret = {}
        this.roomList.forEach(ele => {
          ret[ele.value + ''] = ele.text
        })
        this.roomListMap = ret
      },
      changeVisible(value) {
        if (!value) {
          this.$emit('updateClose')
        }


      },
      vrupdate() {
        this.formData.buildingName = ''
        this.formData.moduleName = ''
        this.formData.projectName = ''
        this.formData.roomName = ''


        this.setbuildingListMap()
        this.setmoduleFid1ListMap()
        this.setmoduleFid2ListMap()
        this.setroomListMap()


        if (this.formData.areaType === 1) {
          this.formData.moduleFid = this.formData.moduleFid1
          this.formData.moduleName = this.moduleFid1ListMap[this.formData.moduleFid1 + '']
          this.formData.roomName = this.roomListMap[this.formData.roomFid + '']
        }
        else {

          this.formData.moduleFid = this.formData.moduleFid2.join(',')
          let arr = []
          this.formData.moduleFid2.forEach(ele => {
            arr.push(this.moduleFid2ListMap[ele + ''])
          })
          this.formData.moduleName = arr.join(',')
        }

        this.formData.projectName = this.projectListMap[this.formData.projectFid + ''].text
        this.formData.buildingName = this.buildingListMap[this.formData.buildingFid + '']

        this.formData['lastModifyTime']=''
        this.formData['lastModifyBy']=''


        vrupdate(this.formData).then(res => {
          // this.loading=false
          this.$emit('updatedone')
          this.$Message.success('修改成功')
          this.isShow = false

        }).catch(error => {
          this.changeLoading()
        })

      },
      clearData() {
        // this.formData = {
        //   moduleFid2: [],
        //   moduleFid1: '',
        //   "areaType": '',
        //   "buildingFid": "",
        //   "moduleFid": "",
        //   "projectFid": "",
        //   "roomFid": "",
        //   "serviceType": '',
        //   "shellHouseId": "",
        // }
        this.houseTypeAndAreaList = []
        this.projectList = []
        this.roomList = []
        this.moduleFid1List = []
        this.moduleFid2List = []
        this.buildingList = []
        this.formData = null

        this.buildingListMap = null
        this.moduleFid1ListMap = null
        this.moduleFid2ListMap = null
        this.roomListMap = null


      },
      changeAreaType(value) {
        this.formData.moduleFid = ''
        this.formData.moduleFid2 = []
        this.formData.moduleFid1 = ''
        // this.moduleFid1List = []
        // this.moduleFid2List = []
        this.formData.roomFid = ''
        this.roomList = []

        // if(value){
        //
        //   if(value===2){
        //     if(this.formData.projectFid && this.formData.buildingFid && this){
        //
        //     }
        //
        //
        //   }
        //   if(value===1){
        //
        //   }
        //   this.forProjectAndBuild()
        //   this.housetypeforProject()
        //   // if(){
        //   //
        //   // }
        //
        // }

      },
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error(' '));
        }
        callback();
      },
      changeModule1() {
        this.formData.roomFid = ''
        this.roomList = []


      },
      forHouseType(query) {
        if (!query) {
          this.roomList = []
          this.formData.roomFid = ''
          return
        }
        let params = {
          projectFid: this.formData.projectFid,
          buildingFid: this.formData.buildingFid,
          houseTypeFid: this.formData.moduleFid1,
          roomnumber: query,
          serviceType: this.formData.serviceType,
        }
        forHouseType(params).then(res => {
          this.roomList = res.data
        }).catch(error => {
        })

      },
      // 根据项目获取房型（包括自如驿）
      housetypeforProject() {
        let params = {
          projectFid: this.formData.projectFid,
          serviceType: this.formData.serviceType,
        }
        housetypeforProject(params).then(res => {
          this.moduleFid1List = res.data
        }).catch(error => {
        })

      },
      // 根据项目和楼栋获取公区（包括自如驿）
      forProjectAndBuild() {
        let params = {
          projectFid: this.formData.projectFid,
          buildingFid: this.formData.buildingFid,
          serviceType: this.formData.serviceType,
        }
        forProjectAndBuild(params).then(res => {
          this.moduleFid2List = res.data
        }).catch(error => {
        })
      },

      projectAndBuild(value) {
        let params = {
          serviceType: value
        }
        projectAndBuild(params).then(res => {
          this.projectList = res.data
        }).catch(error => {
        })


      },
      changeBuild(value) {
        this.formData.moduleFid = ''
        this.formData.moduleFid2 = []
        this.formData.moduleFid1 = ''
        this.moduleFid1List = []
        this.moduleFid2List = []
        this.formData.roomFid = ''
        this.roomList = []
        if (value || value === 0) {
          this.forProjectAndBuild()
          this.housetypeforProject()

        }
      },
      changeProject(value) {
        this.formData.buildingFid = ''
        this.buildingList = []
        this.formData.moduleFid = ''
        this.formData.moduleFid2 = []
        this.formData.moduleFid1 = ''

        this.moduleFid1List = []
        this.moduleFid2List = []

        this.formData.roomFid = ''
        this.roomList = []

        if (value || value === 0) {
          this.buildingList = this.projectListMap['' + value].children
        }
      },
      changeServiceType(value) {
        this.formData.projectFid = ''
        this.projectList = []
        this.formData.buildingFid = ''
        this.buildingList = []
        this.formData.moduleFid = ''
        this.formData.moduleFid2 = []
        this.formData.moduleFid1 = ''

        this.moduleFid1List = []
        this.moduleFid2List = []

        this.formData.roomFid = ''
        this.roomList = []

        if (value || value === 0) {
          this.projectAndBuild(value)
        }
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        this.$refs['formData'].validate(bool => {
          if (bool) {
            this.vrupdate()
          }
          else {
            // this.$Message.info('请检查填写内容！')
            this.changeLoading()
          }
        })

      },
      cancel() {

      }
    }
  }
</script>

<style scoped>

</style>
